import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES]: {
		url: '/company/:companyId/business_processes/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_MAIN_INFO]: {
		url: '/company/:companyId/business_processes/business_processes_main_info/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_POPUP]: {
		url: '/company/:companyId/business_processes/:businessProcessId/popup/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_PREVIEW]: {
		url: '/company/:companyId/business_processes/:businessProcessId/preview/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS]: {
		url: '/company/:companyId/business_processes/:businessProcessId/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS]: {
		url: '/company/:companyId/business_processes/',
		requestOptions: { method: 'POST' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS]: {
		url: '/company/:companyId/business_processes/:businessProcessId/',
		requestOptions: { method: 'PATCH' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS]: {
		url: '/company/:companyId/business_processes/:businessProcessId/',
		requestOptions: { method: 'PUT' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].DELETE_BUSINESS_PROCESS]: {
		url: '/company/:companyId/business_processes/:businessProcessId/',
		requestOptions: { method: 'DELETE' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_CROP]: {
		url: '/company/:companyId/business_processes/create_crop_business_process/',
		requestOptions: { method: 'POST' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_CROP]: {
		url: '/company/:companyId/business_processes/:businessProcessId/update_crop_business_process/',
		requestOptions: { method: 'PUT' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_CROP]: {
		url: '/company/:companyId/business_processes/:businessProcessId/update_crop_business_process/',
		requestOptions: { method: 'PATCH' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].MULTI_SET_CULTURE]: {
		url: '/company/:companyId/business_processes/multi/set_culture/',
		requestOptions: { method: 'PATCH' },
	},

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGES]: {
		url: '/company/:companyId/business_processes/active_stages/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE]: {
		url: '/company/:companyId/business_processes/active_stages/:activeStageId/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_POPUP]: {
		url: '/company/:companyId/business_processes/active_stages/popup/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_PREVIEW]: {
		url: '/company/:companyId/business_processes/active_stages/:activeStageId/preview/',
	},

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_CATEGORIES]: {
		url: '/company/:companyId/business_processes/active_stages/finance/by_categories/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_DESTINATION]: {
		url: '/company/:companyId/business_processes/active_stages/finance/by_destination/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_WORK_TYPES]: {
		url: '/company/:companyId/business_processes/active_stages/finance/by_work_types/',
	},
	
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_UNIVERSAL]: {
		url: '/company/:companyId/business_processes/create_universal_business_process/',
		requestOptions: { method: 'POST' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_UNIVERSAL]: {
		url: '/company/:companyId/business_processes/:businessProcessId/update_universal_business_process/',
		requestOptions: { method: 'PATCH' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_UNIVERSAL]: {
		url: '/company/:companyId/business_processes/:businessProcessId/update_universal_business_process/',
		requestOptions: { method: 'PUT' },
	},
}
